import './style.css'
import './polyfills/index.ts'

const authorizationReturn = new URLSearchParams(location.search).has('state')

if (authorizationReturn) {
	new BroadcastChannel('shuttle-authorization').postMessage({ url: location.href })
	history.replaceState(null, '', location.pathname)
}

if ('serviceWorker' in navigator && !import.meta.env.DEV) {
	addEventListener('load', () => navigator.serviceWorker.register('/sw.js'))
}

if ('serviceWorker' in navigator && import.meta.env.DEV) {
	void navigator.serviceWorker.getRegistrations().then(registrations => registrations.forEach(registration => registration.unregister()))
}

if (!authorizationReturn && import.meta.env.DEV) await import('./dev/mock.ts')

if (!authorizationReturn) await import('./app.ts')
